import { getImageDimensions } from '@/components/lomavisCreator/utils/helpers';

/* Return a promise that resolves with the cropped image
parameters:
- imageUrl: the URL of the image to crop
- cropData: an object containing the cropping parameters (x, y, width, height
*/
export async function cropImage(
  imageUrl: string,
  cropData: any
): Promise<string> {
  return await new Promise((resolve, reject) => {
    // Create an image element
    const image = new Image();
    image.crossOrigin = 'Anonymous'; // This is important if you're working with external images

    // Set the source of the image
    image.src = imageUrl;

    // Wait for the image to load
    image.onload = () => {
      // Create a canvas element
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      // Set the canvas dimensions to the crop dimensions
      canvas.width = cropData.width;
      canvas.height = cropData.height;

      // Draw the cropped image onto the canvas
      ctx.drawImage(
        image,
        cropData.x,
        cropData.y,
        cropData.width,
        cropData.height, // Source image and cropping parameters
        0,
        0,
        cropData.width,
        cropData.height // Destination canvas parameters
      );

      // Get the cropped image as a data URL
      canvas.toBlob((blob) => {
        const croppedImageUrl = URL.createObjectURL(blob);
        resolve(croppedImageUrl);
        // Use croppedImageUrl as needed
      }, 'image/jpeg');

      // Resolve the promise with the cropped image URL
    };

    // Handle image loading error
    image.onerror = (error) => {
      console.error('Failed to load image:', error);
      reject(error);
    };
  });
}
export async function cropPreviewImage(
  imageUrl: string,
  originalDimension: any,
  cropData: any
): Promise<string> {
  console.log('feederrr', cropData);
  const ImageDimensions = await getImageDimensions(imageUrl);

  const adjustedCropData = {
    ...cropData,
    height:
      (cropData.height / originalDimension.height) * ImageDimensions.height,
    width: (cropData.width / originalDimension.width) * ImageDimensions.width,
    x: (cropData.x / originalDimension.width) * ImageDimensions.width,
    y: (cropData.y / originalDimension.height) * ImageDimensions.height
  };

  const croppedUrl = await cropImage(imageUrl, adjustedCropData);
  console.log('feed', cropData, adjustedCropData, croppedUrl);
  return croppedUrl;
}
